// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenedor de métodos de pago */
.botones-pago {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 2rem;
  padding: 0.5rem;
  scroll-snap-type: x mandatory;
}

/* Botón con imagen centrada y texto debajo */
.metodo-icono {
  width: 120px;
  height: auto;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.3s ease;
  text-align: center;
  scroll-snap-align: start;
}

/* Imagen dentro del botón */
.metodo-icono img {
  width: 70px;
  height: 70px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

/* Texto debajo del ícono */
.metodo-icono span {
  margin-top: 0.5rem;
  font-weight: 500;
  color: var(--sn-texto);
  font-size: 0.85rem;
  line-height: 1.1;
  word-break: break-word;
}

/* Hover agranda imagen */
.metodo-icono:hover img {
  transform: scale(1.15);
}

/* Botón seleccionado con brillo animado */
.metodo-icono.selected {
  animation: glow 1.5s infinite ease-in-out;
  border-radius: 12px;
}

/* Efecto brillo pulsante (acento de marca sobre el método elegido) */
@keyframes glow {
  0% {
    box-shadow: 0 0 0 3px var(--sn-marca-suave);
  }
  50% {
    box-shadow: 0 0 15px 3px var(--sn-marca);
  }
  100% {
    box-shadow: 0 0 0 3px var(--sn-marca-suave);
  }
}

/* Caja de leyenda de cada método */
.leyenda-box {
  background: var(--sn-superficie);
  border: 1px solid var(--sn-borde);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: var(--sn-sombra);
  font-size: 0.95rem;
}

/* Botón circular tipo "Atrás" */
.btn-circular-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.btn-circular {
  width: 60px;
  height: 60px;
  background-color: var(--sn-accion);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sn-accion-texto);
  font-size: 24px;
  box-shadow: var(--sn-sombra);
  transition: background-color 0.3s ease;
}

.btn-circular:hover {
  background-color: var(--sn-accion-hover);
}

.btn-label {
  margin-top: 5px;
  font-weight: 500;
  color: var(--sn-texto);
}
@keyframes pulsar-logo {
  0% { opacity: 0.3; transform: scale(0.98); }
  50% { opacity: 1; transform: scale(1); }
  100% { opacity: 0.3; transform: scale(0.98); }
}

.logo-cargando {
  animation: pulsar-logo 1.5s infinite ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/pages/Pagos.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA,6CAA6C;AAC7C;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA,mCAAmC;AACnC;EACE,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,KAAK,YAAY,EAAE,sBAAsB,EAAE;EAC3C,MAAM,UAAU,EAAE,mBAAmB,EAAE;EACvC,OAAO,YAAY,EAAE,sBAAsB,EAAE;AAC/C;;AAEA;EACE,gDAAgD;AAClD","sourcesContent":["/* Contenedor de métodos de pago */\n.botones-pago {\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  gap: 2rem;\n  padding: 0.5rem;\n  scroll-snap-type: x mandatory;\n}\n\n/* Botón con imagen centrada y texto debajo */\n.metodo-icono {\n  width: 120px;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  text-align: center;\n  scroll-snap-align: start;\n}\n\n/* Imagen dentro del botón */\n.metodo-icono img {\n  width: 70px;\n  height: 70px;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n/* Texto debajo del ícono */\n.metodo-icono span {\n  margin-top: 0.5rem;\n  font-weight: 500;\n  color: var(--sn-texto);\n  font-size: 0.85rem;\n  line-height: 1.1;\n  word-break: break-word;\n}\n\n/* Hover agranda imagen */\n.metodo-icono:hover img {\n  transform: scale(1.15);\n}\n\n/* Botón seleccionado con brillo animado */\n.metodo-icono.selected {\n  animation: glow 1.5s infinite ease-in-out;\n  border-radius: 12px;\n}\n\n/* Efecto brillo pulsante (acento de marca sobre el método elegido) */\n@keyframes glow {\n  0% {\n    box-shadow: 0 0 0 3px var(--sn-marca-suave);\n  }\n  50% {\n    box-shadow: 0 0 15px 3px var(--sn-marca);\n  }\n  100% {\n    box-shadow: 0 0 0 3px var(--sn-marca-suave);\n  }\n}\n\n/* Caja de leyenda de cada método */\n.leyenda-box {\n  background: var(--sn-superficie);\n  border: 1px solid var(--sn-borde);\n  border-radius: 12px;\n  padding: 1rem 1.25rem;\n  box-shadow: var(--sn-sombra);\n  font-size: 0.95rem;\n}\n\n/* Botón circular tipo \"Atrás\" */\n.btn-circular-wrapper {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n}\n\n.btn-circular {\n  width: 60px;\n  height: 60px;\n  background-color: var(--sn-accion);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--sn-accion-texto);\n  font-size: 24px;\n  box-shadow: var(--sn-sombra);\n  transition: background-color 0.3s ease;\n}\n\n.btn-circular:hover {\n  background-color: var(--sn-accion-hover);\n}\n\n.btn-label {\n  margin-top: 5px;\n  font-weight: 500;\n  color: var(--sn-texto);\n}\n@keyframes pulsar-logo {\n  0% { opacity: 0.3; transform: scale(0.98); }\n  50% { opacity: 1; transform: scale(1); }\n  100% { opacity: 0.3; transform: scale(0.98); }\n}\n\n.logo-cargando {\n  animation: pulsar-logo 1.5s infinite ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
